import React from "react";
import {useSelector} from "react-redux";
import {Card, CardContent, Grid, IconButton, Typography,Link} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {TableView} from "../../Common";
import {RootState} from "../../../reducers";
import {AccountType} from "../../../constants";
import {checkRole} from "../../../utils/commonUtils";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import moment from "moment";


interface ConfirmGiftorProps {
    onEditStatus: () => void;
    clientDetail?: any
}


const ConfirmGiftor: React.FC<ConfirmGiftorProps> = ({onEditStatus, clientDetail}) => {
    const {user} = useSelector((state: RootState) => state.auth);
    const profile = useSelector((state: RootState) => state.profile);
    const userData = clientDetail ? clientDetail : profile;
    const employeeSSN: any = userData && userData.client && (userData.client.employeeSSN || userData.client.blotSSN);
    const role = user && user.role;
    const isEditAllowed = checkRole(role, [AccountType.Agent, AccountType.Individual, AccountType.Multilife]);
    const isEditAllowedIndividualOnly = checkRole(role, [AccountType.Individual]);
    const EditableField = ({ value, isEditAllowed, onEdit }) => {
        return (
            <>
                {
                    isEditAllowed ? (
                        <Link className="cursorPointer" onClick={onEdit}>
                            {value}
                        </Link>
                    ) : (
                        value
                    )
                }
            </>
        );
    };

    const gridProps = {
        headers: ["First Name", "Last Name", "Email", "Cell Phone", "Date of Birth", "Gender", "SSN", "Actions"],
        list: [
            {
                firstName: (
                      <EditableField
                          value={userData.firstName}
                          isEditAllowed={isEditAllowed}
                          onEdit={onEditStatus}
                      />
                 ),
                lastName: (
                      <EditableField
                          value={userData.lastName}
                          isEditAllowed={isEditAllowed}
                          onEdit={onEditStatus}
                      />
                 ),
                email: userData.email,
                phoneNumber: userData.phoneNumber,
                dob: moment(userData && userData.client && userData.client.dob).format("MM/DD/YYYY"),
                gender: userData.client && userData.client.gender === 1 ? "Male" : "Female",
                employeeSSN: employeeSSN,
                action: (
                        <IconButton className="cursorPointer" onClick={onEditStatus}>
                            {
                                    isEditAllowedIndividualOnly &&
                                    <EditIcon color="action" />
                            }
                            {
                                    !isEditAllowedIndividualOnly &&
                                    <VisibilityOutlinedIcon color="action"/>
                            }
                        </IconButton>
                ),
            },
        ],
        noRowsMsg: "No recipients found.",
    };

    return (
            <Card className="boxShadow mt20">
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h3" className="mt20 mb10">
                                Giftor Details
                            </Typography>
                            <Typography variant="body2" color="textPrimary" className="mt10">
                                Click on the giftor's name or the pencil icon to edit the giftor's details.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableView {...gridProps} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
    );
};

export default ConfirmGiftor;